import { render, staticRenderFns } from "./NewViewOrderDetails.vue?vue&type=template&id=704f3b84&scoped=true&"
import script from "./NewViewOrderDetails.vue?vue&type=script&lang=js&"
export * from "./NewViewOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./NewViewOrderDetails.vue?vue&type=style&index=0&id=704f3b84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704f3b84",
  null
  
)

export default component.exports